import React from 'react';
import { format } from 'date-fns';
import { WarningRounded } from '@material-ui/icons';
import ModalConfirm from '../../../../../../components/ModalConfirm';

export const BlockAccessModal = ({
  isLoading,
  blockAccessExpiresAt,
  setBlockAccessExpiresAt,
  isIndefiniteBlockAccess,
  setIsIndefiniteBlockAccess,
  onConfirm,
  onClose,
}) => (
  <ModalConfirm
    icon={WarningRounded}
    title="Bloquear acesso do cliente?"
    message="Esta ação impedirá o cliente de acessar a plataforma Jusfy."
    onConfirm={onConfirm}
    isLoading={isLoading}
    onClose={onClose}
  >
    <div style={{ marginBottom: 16, textAlign: 'left' }}>
      <label
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: 'pointer',
        }}
      >
        <input
          type="checkbox"
          style={{ width: 16, height: 16, margin: 0 }}
          checked={isIndefiniteBlockAccess}
          onChange={(e) => {
            setIsIndefiniteBlockAccess(e.target.checked);
            if (e.target.checked) {
              setBlockAccessExpiresAt('');
            }
          }}
        />
        <strong>Bloqueio indefinido</strong>
      </label>

      {!isIndefiniteBlockAccess && (
        <div style={{ marginTop: 12 }}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 600 }}>
            Bloquear até quando?
          </label>
          <input
            type="date"
            className="form-control"
            value={blockAccessExpiresAt}
            min={format(new Date(), 'yyyy-MM-dd')}
            onChange={(e) => setBlockAccessExpiresAt(e.target.value)}
          />
        </div>
      )}
    </div>
  </ModalConfirm>
);
